import { useEffect, useMemo, useState } from 'react';
import { Common } from '@thecvlb/design-system';

import { useGetInterpreterLanguagesQuery } from 'services/calls/calls';

import { useZoomCall } from 'hooks';
import { useWidth } from 'hooks/useWidth';
import { IS_LIVE } from 'utils/constants';

import { getSingleSelectedOption, TEST_INTERPRETER_LANGUAGES } from './requestInterpreter.settings';

const RequestInterpreter = () => {
  const { isMobile } = useWidth();
  const { data: languageData } = useGetInterpreterLanguagesQuery();

  const {
    isOpenRequestInterpreter,
    languageRequested,
    setLanguageRequested,
    toggleIsOpenRequestInterpreter
  } = useZoomCall();

  const [language, setLanguage] = useState(languageRequested);

  const interpreterLanguages = useMemo(
    () =>
      IS_LIVE
        ? languageData?.data || []
        : [...TEST_INTERPRETER_LANGUAGES, ...(languageData?.data || [])],
    [languageData?.data]
  );

  const options = useMemo(() => {
    const items = interpreterLanguages ?? [];
    return [
      {
        label: 'Video',
        options: items
          .filter((item) => item.type.includes('video'))
          .map((item) => ({ label: item.language, value: item.sipAddress }))
      },
      {
        label: 'Audio only',
        options: items
          .filter((item) => item.type.includes('audio'))
          .map((item) => ({ label: item.language, value: item.sipAddress }))
      }
    ];
  }, [interpreterLanguages]);

  const handleChangeLanguage = (data: unknown) => {
    const selected = getSingleSelectedOption(data);
    if (selected) setLanguage(selected);
  };

  const handleSave = () => {
    setLanguageRequested(language);
    toggleIsOpenRequestInterpreter();
  };

  useEffect(() => {
    if (isOpenRequestInterpreter) setLanguage(languageRequested);
  }, [isOpenRequestInterpreter, languageRequested]);

  return (
    <Common.Modal
      close={toggleIsOpenRequestInterpreter}
      isOpen={isOpenRequestInterpreter}
      size="sm"
      title="Request interpreter"
      autoScroll={false}
      persist
    >
      <div className="mt-4 p-1">
        <Common.MultiSelect
          label="Language options"
          options={options}
          value={language}
          placeholder="Select a language"
          onChange={handleChangeLanguage}
          size={isMobile ? 'lg' : 'sm'}
          menuPlacement={isMobile ? 'top' : 'auto'}
        />
      </div>
      <div className="mt-6 flex gap-2">
        <Common.Button
          className="!w-full justify-center"
          size={isMobile ? 'md' : 'sm'}
          color="white-alt"
          fullWidthOnMobile
          onClick={toggleIsOpenRequestInterpreter}
        >
          Cancel
        </Common.Button>
        <Common.Button
          className="!w-full justify-center"
          disabled={!language}
          size={isMobile ? 'md' : 'sm'}
          color="blue"
          onClick={handleSave}
        >
          Save
        </Common.Button>
      </div>
    </Common.Modal>
  );
};

export default RequestInterpreter;
